module.exports.mod11 = require('./lib/mod11');
module.exports.mod10 = require('./lib/mod10');



//////////////////
// WEBPACK FOOTER
// ./~/checkdigit/index.js
// module id = 69
// module chunks = 1